import React from "react";
import { Box, Button, LinearProgress, Typography, Grid2 } from "@mui/material";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import HeaderField from "./preChartHeaderField";

const PreChartNote = ({
  selectedNote,
  handleSaveNote,
  userPrechartNote,
  setUserPrechartNote,
  loading,
  setSelectedNote,
  data,
  row,
}) => {
  const onChange = (value) => {
    setSelectedNote(value);
    setUserPrechartNote(value);
  };
  return (
    <Box>
      <Box
        mb={2}
        p={2}
        sx={{
          background: "#f8f9fa",
          borderRadius: 2,
          boxShadow: 1,
        }}
      >
        <Grid2 container spacing={2}>
          <HeaderField
            label="Patient Name:"
            value={`${row?.first_name} ${row?.last_name}`}
          />
          <HeaderField label="Patient ID:" value={data?.patient_id} />
          <HeaderField label="Encounter ID:" value={data?.encounter_id} />
          <HeaderField label="Appointment Time:" value={row?.dos_time} />
          <HeaderField label="Status:" value={row?.status} />
          <HeaderField
            label="Missing Information:"
            value={data?.missing_information}
            color="red"
            highlight={data?.missing_information === "Yes"}
          />
          <HeaderField
            label="AI Confidence Score:"
            value={data?.ai_conf_score}
          />
          <HeaderField
            label="AI Justification Notes:"
            value={data?.ai_justification_notes}
            xs={12}
            sm={12}
            md={9}
          />
          <HeaderField label="Created Date:" value={data?.created_date} />
          <HeaderField label="Created By:" value={data?.created_by} />
          <HeaderField
            label="Last Updated Date:"
            value={data?.last_updated_date}
          />
          <HeaderField label="Last Updated By:" value={data?.last_updated_by} />
        </Grid2>
      </Box>

      <Box display="flex" alignItems="flex-start" width="100%" gap={2}>
        <Box flex={1} mr={1}>
          <Typography fontSize={18} fontWeight={500}>
            Pre Charting Note
          </Typography>

          <Box flex={1} mr={1} pb={5}>
            <Box display={"flex"} justifyContent={"flex-end"} mb={2}>
              <Button
                variant="text"
                color="primary"
                onClick={handleSaveNote}
                disabled={!userPrechartNote.trim() || loading}
              >
                Save Note
              </Button>
            </Box>
            {loading && <LinearProgress />}
            <ReactQuill
              theme="snow"
              value={userPrechartNote ? userPrechartNote : selectedNote}
              onChange={onChange}
              style={{ height: "50vh" }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default PreChartNote;
